module.exports = __webpack_public_path__ + "static/media/exclamanation.bdac3c3e.png";